// IMPORTANT: instrument.js must be the very first import so Sentry
// can capture errors that occur during module initialization.
import './instrument'

import { createRoot } from 'react-dom/client'
import './i18n'
import './index.css'
import App from './App'

// StrictMode removed — it causes GSAP animations to double-fire and die
createRoot(document.getElementById('root')).render(<App />)
